export const BASE_URL = "https://prod.easypointapi.com/api"